/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {ChargeLevelIconProps} from '../ChargeLevelIcon';

/*
 * Defines the Design Language System (DLS) Charge Level Icon component.
 */
export const ChargeLevelIcon = ({
  size = 16,
  color,
  outlineColor = dlsColor('white')
}: ChargeLevelIconProps) => {
  return (
    <svg width={size} height={size} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M11.4606 11H2.2894C2.13023 11 2 10.8768 2 10.7262V5.27385C2 5.12323 2.13023 5 2.2894 5L11.4606 5C11.6198 5 11.75 5.12323 11.75 5.27385V10.7262C11.75 10.8781 11.6198 11 11.4606 11Z' fill={outlineColor} />
      <path d='M14 10.1277V5.87207H12.4683V10.1277H14Z' fill={color} />
      <path d='M11.75 10.7266C11.7498 10.8782 11.6198 10.9998 11.4609 11H2.28906C2.13019 10.9998 2.00024 10.8769 2 10.7266V5.27344C2.00024 5.12312 2.13019 5.00018 2.28906 5L11.4609 5C11.6198 5.00018 11.7498 5.12312 11.75 5.27344V10.7266Z' fill={color} />
      <path d='M11.75 10.7266C11.7498 10.8782 11.6198 10.9998 11.4609 11H2.28906C2.13019 10.9998 2.00024 10.8769 2 10.7266V5.27344C2.00024 5.12312 2.13019 5.00018 2.28906 5L11.4609 5C11.6198 5.00018 11.7498 5.12312 11.75 5.27344V10.7266Z' stroke={color} />
      <path d='M7.77344 5.52148C7.88387 5.56318 7.94134 5.66118 7.91504 5.75488L7.45996 7.375H9.23633C9.34159 7.375 9.43904 7.42781 9.47852 7.50488C9.52034 7.58179 9.49981 7.67112 9.42383 7.73145L6.00195 10.4395C5.95197 10.479 5.88641 10.5 5.81543 10.5C5.76545 10.5 5.71787 10.4896 5.67578 10.4688C5.57327 10.4166 5.52598 10.3162 5.56543 10.2246L6.23926 8.625H4.7627C4.66012 8.62496 4.56552 8.57678 4.52344 8.50391C4.48155 8.42901 4.49687 8.34366 4.5625 8.28125L7.45801 5.57324C7.53698 5.50053 7.66566 5.47987 7.77344 5.52148Z' stroke={color} />
    </svg>
  );
};

export default ChargeLevelIcon;
